import React from "react";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import MainPage from "./components/MainPage";
import HomePage from "./components/Home";
import BecomeMentor from "./components/BecomeMentor";
import FindMentor from "./components/GetMentor";
import AboutUs from "./components/AboutUs";
import Logout from "./components/Logout";
import Faq from "./components/Faq";
import MentorForm from "./components/BecomeMentorForms";
import CohortForm from "./components/CohortForms";
import CohortStartupsForm from "./components/CohortForms/CohortStartup";
import ViewApplicationCohort from "./components/AdminModule/Dashboard/MentorDashboard/ViewApplicationCohort";
import StartupForms from "./components/StartupForms";
import LoginModal from "./components/StartupForms/LoginModal";
import SingleMentor from "./components/GetMentor/components/SingleMentor/SingleMentor";
import CohortProgram from "./components/CohortProgram";
import CohortParticular from "./components/CohortParticular";
import AllCohortPrograms from "./components/AllCohortPrograms";
import AdminHome from "./components/AdminModule/AdminHome";
import ViewApplication from "./components/AdminModule/Dashboard/AdminDashboard/ViewApplication";
import AdminMentorAction from "./components/AdminModule/Dashboard/AdminDashboard/AdminMentorAction";
import ComingSoon from "./components/common/ComingSoon";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { LinkedInCallback } from "react-linkedin-login-oauth2";
import StartupDashboard from "./components/AdminModule/Dashboard/StartupDashboard/StartupMyRequest";
import StartupProfile from "./components/AdminModule/Dashboard/StartupDashboard/SingleStartUp/SingleStartUp";
import Mentorships from "./components/AdminModule/Dashboard/AdminDashboard/Mentorships";
import MentorMatchList from "./components/AdminModule/Dashboard/StartupDashboard/MentorMatchList";
// import StartUpList from "./components/AdminModule/Dashboard/StartupDashboard/StartupList";
import ContactUs from "./components/ContactUs";
import PageNotFound from "./components/PageNotFound";
import MyRequestAction from "./components/AdminModule/Dashboard/MentorDashboard/MyRequestAction";
import ViewApplicationStartup from "./components/AdminModule/Dashboard/StartupDashboard/ViewApplicationStartup";
// import ScrollToTop from './scrollToTop'
import httpService from "./axios-interceptors";
import MentorEngagementSummary from "./components/AdminModule/Dashboard/StartupDashboard/MentorEngagementSummary";
import AdminMentorships from "./components/AdminModule/Dashboard/AdminDashboard/Mentorships";
import AdminMentorMentorships from "./components/AdminModule/Dashboard/AdminDashboard/MentorMentorships";
import MentorMentorEngagementSummary from "./components/AdminModule/Dashboard/MentorDashboard/MentorEngagementSummary";
import ViewAllMentorList from "./components/AdminModule/Dashboard/StartupDashboard/ViewAllMentorList";
import CohortSessionList from "./components/AdminModule/Dashboard/MentorDashboard/CohortSessionList";
// import CohortRecordingList from "./components/AdminModule/Dashboard/MentorDashboard/CohortRecordingList";
import ChatBox from "./components/common/chatBox";
httpService.setupInterceptors();
const AppRoutes = () => (
  <BrowserRouter>
    {/* <ScrollToTop /> */}
    <Switch>
      <Route
        exact
        path="/become-mentor"
        component={() => <MainPage content={BecomeMentor} />}
      />
      <Route
        exact
        path="/about-us"
        component={() => <MainPage content={AboutUs} />}
      />
      <Route
        exact
        path="/logout"
        component={() => <MainPage content={Logout} />}
      />
      <Route
        exact
        path="/get-a-mentor"
        component={() => <MainPage content={FindMentor} />}
      />
      <Route
        exact
        path="/become-a-mentor"
        component={() => <MainPage content={MentorForm} />}
      />
      <Route
        exact
        path="/cohort-program"
        component={() => <MainPage content={CohortProgram} />}
      />
      {/* <Route
        exact
        path="/cohort-recordingList"
        component={() => <MainPage content={CohortRecordingList} />}
      /> */}
       <Route
        exact
        path="/cohort-programs/all"
        component={() => <MainPage content={AllCohortPrograms} />}
      />
       <Route
        exact
        path="/cohort-programs/all/:cohortId"
        component={() => <MainPage content={CohortParticular} />}
      /> 
<Route
        exact
        path="/cohort-programs/cohortView/:cohortId"
        component={() => <MainPage content={CohortSessionList} />}
      /> 
      <Route
        exact
        path="/my-request-action"
        component={() => <MainPage content={MyRequestAction} />}
      />
      <Route
        exact
        path="/cohort-form"
        component={() => <MainPage content={CohortForm} />}
      />
      <Route
        exact
        path="/cohort-startup-form"
        component={() => <MainPage content={CohortStartupsForm} />}
      />
      <Route
        exact
        path="/startup-form"
        component={() => <MainPage content={StartupForms} />}
      />

      {/* <Route
        exact
        path="/startup-list"
        component={() => <MainPage content={StartUpList} />}
      /> */}
      {/* <Route
        exact
        path="/get-a-mentor"
        component={() => <MainPage content={StartupForms} />}
      /> */}
      <Route
        exact
        path="/contactus"
        component={() => <MainPage content={ContactUs} />}
      />
      <Route
        exact
        path="/login"
        component={() => (
          <GoogleOAuthProvider
            clientId="903437362834-0rgqj71ur2aurron6v4elggt77frae50.apps.googleusercontent.com"
            scope="email"
          >
            <MainPage content={LoginModal} />
          </GoogleOAuthProvider>
        )}
      />

      <Route
        exact
        path="/dpiit/token=:id"
            component={() => (
              <GoogleOAuthProvider
                clientId="903437362834-0rgqj71ur2aurron6v4elggt77frae50.apps.googleusercontent.com"
                scope="email"
              >
                <MainPage content={LoginModal} />
              </GoogleOAuthProvider>
            )}
      />
      <Route exact path="/" component={() => <MainPage content={HomePage} />} />
      {/* <Route exact path="/:id" component={() => <MainPage content={HomePage} />} /> */}
      <Route
        exact
        path="/mentor-profile/:id"
        component={() => <MainPage content={SingleMentor} />}
      />
      <Route
        exact
        path="/chatBox"
        component={() => <MainPage content={ChatBox} />}
      />
      <Route
        exact
        path="/dashboard"
        component={() => <MainPage content={AdminHome} />}
      />
      <Route
        exact
        path="/dashboard/mentorship/:startupId"
        component={() => <MainPage content={AdminMentorships} />}
      />
      <Route
        exact
        path="/dashboard/mentorship-mentor/:mentorId"
        component={() => <MainPage content={AdminMentorMentorships} />}
      />
      <Route
        exact
        path="/view-Application/:id"
        component={() => <MainPage content={ViewApplication} />}
      />
      <Route
        exact
        path="/view-StartupApplication/:id"
        component={() => <MainPage content={ViewApplicationStartup} />}
      />
      <Route
        exact
        path="/view-CohortApplication/:id"
        component={() => <MainPage content={ViewApplicationCohort} />}
      />

      <Route
        exact
        path="/mentor-action"
        component={() => <MainPage content={AdminMentorAction} />}
      />
      <Route
        exact
        path="/startup-profile/:id"
        component={() => <MainPage content={StartupProfile} />}
      />
      <Route
        exact
        path="/coming-soon"
        component={() => <MainPage content={ComingSoon} />}
      />

      <Route exact path="/faq" component={() => <MainPage content={Faq} />} />
      <Route
        exact
        path="/startup-dashboard"
        component={() => <MainPage content={AdminHome} />}
      />
      <Route
        exact
        path="/startup-dashboard/mentorships/:startupId"
        component={() => (
          <MainPage content={Mentorships} style={{ paddingTop: "100px" }} />
        )}
      />
      <Route
        exact
        path="/startup-dashboard/match-list/:searchId"
        component={() => <MainPage content={MentorMatchList} />}
      />
      <Route
        exact
        path="/startup-dashboard/mentorships/engagement-summary/:mentorshipId"
        component={() => (
          <MainPage
            style={{ paddingTop: "100px" }}
            content={MentorEngagementSummary}
          />
        )}
      />
      <Route
        exact
        path="/mentor-dashboard/mentorships/engagement-summary/:mentorshipId"
        component={() => (
          <MainPage
            style={{ paddingTop: "100px" }}
            content={MentorMentorEngagementSummary}
          />
        )}
      />
      <Route
        exact
        path="/startup-dashboard/all-mentor-list"
        component={() => (
          <MainPage
            style={{ paddingTop: "100px" }}
            content={ViewAllMentorList}
          />
        )}
      />
      <Route exact path="/linkedin" component={LinkedInCallback} />
      <Route
        exact
        path="*"
        component={() => <MainPage content={PageNotFound} />}
      />
    </Switch>
  </BrowserRouter>
);
export default AppRoutes;
